import { useAuthStore } from "@/state/pinia";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        const auth = useAuthStore();
        // If the user is already logged in
        // if (store.getters["auth/loggedIn"]) {
        if (auth.loggedIn) {
          // Redirect to the home page instead
          next({ name: "dashboard-overview" });
        } else {
          // Continue to the login page
          next();
        }
      }
    }
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/account/logout"),
    meta: {
      title: "Logout",
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const auth = useAuthStore();
        auth.logout();

        // Determine if the previous route required authentication
        const cameFromProtected = routeFrom.matched.some(
          (record) => record.meta && record.meta.authRequired
        );

        // Navigate appropriately after logout
        if (!routeFrom.name || cameFromProtected) {
          // If there's no previous route or it was protected, go to login/home
          next({ name: "login" });
        } else {
          // Otherwise, return to previous public route
          next({ ...routeFrom });
        }
      }
    }
  },
]
